export const apiRoutes = {
  dashboardData: "dashboard/main",
  logsList: "log/issues",

  // AI
  generateAIText: "ai/generateText",
  generateAITranslateText: "ai/generate-translate",
  createAIText: "ai/createText",
  // SEO
  setSeoAtrs: "seo/set-attributes",
  getSeoAtrs: "seo/get-attributes",
  // Analytic
  globalCasinoAnalytic: "analytic/global/casino",
  paymentAnalytic: "analytic/payment/providers",
  paymentAnalyticDeposits: "analytic/payment/deposits",
  gamesAnalytics: "analytic/game/list",
  providersAnalytics: "analytic/game/providers",
  sportCategoriesAnalytics: "analytic/sport/categories",
  sportCompetitionsAnalytics: "analytic/sport/list",
  // Payments
  playerFinancialSummary: "payment/user/financial-summary",
  paymentProvidersList: "payment/provider/list",
  paymentProvidersItem: "payment/provider",
  paymentProviderCreate: "payment/provider/create",
  paymentProvidersUpdate: "payment/provider/update",
  paymentProvidersUpdateBunch: "payment/provider/bunch-update",
  paymentProvidersDelete: "payment/provider/delete",
  paymentProvidersSetTranslations: "payment/provider/set-translation",
  paymentProvidersGetTranslations: "payment/provider/translation",
  paymentMethodList: "payment/method/list",
  paymentMethodItem: "payment/method",
  paymentMethodCreate: "payment/method/create",
  paymentMethodUpdate: "payment/method/update",
  paymentMethodUpdateBunch: "payment/method/bunch-update",
  paymentMethodDelete: "payment/method/delete",
  paymentMethodInternalList: "payment/method/internal-list",
  paymentMethodSetConfig: "payment/method/set-config",
  paymentMethodGetConfig: "payment/method/get-config",
  paymentCreateDeposit: "payment/deposit/attempt",
  paymentManualWithdrawalPrepare: "payment/manual-withdrawal/prepare",
  paymentManualWithdrawalExecute: "payment/manual-withdrawal/execute",
  paymentManualDeposit: "payment/manual-deposit",
  paymentDepositReconciliation: "payment/deposit-reconciliation",
  paymentCompensation: "payment/compensation",
  paymentCompensationsList: "payment/compensation/list",
  paymentConfiscation: "payment/confiscation",
  paymentConfiscationsList: "payment/confiscation/list",
  paymenDepositsList: "payment/deposit/list",
  paymentDepositModifyStatus: "payment/deposit/modify-status",
  paymentWithdrawalsList: "payment/withdrawal/list",
  paymentWithdrawalStatuses: "payment/withdrawal/status/list",
  paymentWithdrawalModifyStatus: "payment/withdrawal/modify-status",
  paymentOperationsList: "payment/operations/list",
  paymentDepositStatuses: "payment/deposit/status/list",
  paymentDepositChangeStatus: "payment/deposit/modify-status",
  paymentCurrenciesList: "payment/currency/list",
  paymentCurrenciesRatesMap: "payment/currency/rates-map",
  paymentCurrenciesSync: "payment/currency/sync",
  paymentCurrencies: "payment/currency",
  paymentCurrenciesRefreshRates: "payment/currency/rates/refresh",
  paymentSystemCurrency: "/system/currency",
  paymentCurrenciesManualRate: "payment/currency/manual-rate",
  paymentMethodCashierFields: "payment/method/cashier-fields",
  // User
  login: "user/auth/sign-in",
  confirm2fa: "user/auth/confirm-2fa",
  me: "user/me",
  // Notifications
  notificationsList: "notification/list",
  notificationCreate: "notification/create",
  notificationUpdate: "notification/update",
  notificationUpdateBunch: "notification/bunch-update",
  notificationDelete: "notification/delete",
  notificationItem: "notification",
  notificatioSend: "notification/send",
  notificationCategories: "notification/categories",
  notificationAutoTriggers: "notification/auto-triggers",
  notificationTranslation: "notification/translation",
  notificationSetTranslation: "notification/set-translation",
  notificationPlaceholders: "notification/placeholders",
  notificationTargetTypes: "notification/target-types",
  notificationManualDispatch: "notification/manual/dispatch",
  // Email
  emailTemplateList: "email/template/list",
  emailTemplateItemDelete: "email/template/delete",
  emailTemplateItemCreate: "email/template/create",
  emailTemplateItemUpdate: "email/template/update",
  emailTemplateTypes: "email/types",
  emailTemplateItem: "email/template",
  emailTemplateTranslationsSet: "email/template/set-translation",
  emailTemplateTranslationsGet: "email/template/translation",
  // Mirrors
  zonesList: "mirror/zones",
  zoneItem: "mirror/zone",
  mirrorCreate: "mirror/create",
  mirrorUpdate: "mirror/update",
  mirrorDisable: "mirror/disable",
  mirrorList: "mirror/list",
  mirrorEnable: "mirror/enable",
  mirrorSetDefault: "mirror/set-default",
  countriesList: "mirror/countries",
  countriesUpdate: "mirror/update-countries",
  countriesDelete: "mirror/remove-countries",
  // Live ops
  wagersList: "game/wager/list",
  wagerCreate: "game/wager/create",
  wagerEdit: "game/wager/update",
  wagerItem: "game/wager",
  wagerDelete: "game/wager/delete",
  wagerGames: "game/wager/not-processed-games",
  wagerGamesUpdateBunch: "game/wager/bunch-update",
  wagerAddGames: "game/wager",
  wagerListGames: "game/wager/games",
  wagerRemoveGames: "game/wager",
  bonusesList: "bonus/list",
  bonusesTypesList: "bonus/type/list",
  bonusesStatusList: "bonus/status/list",
  bonusCreate: "bonus/create",
  bonusSetRules: "bonus/set-rules",
  bonusSetRewards: "bonus/set-rewards",
  bonusSportsbookTemplates: "bonus/sportsbook/templates",
  bonusSetBets: "bonus/set-bets",
  bonusSetTranslations: "bonus/set-translation",
  bonusGetTranslations: "bonus/translation",
  bonusUpdate: "bonus/update",
  bonusUpdateBunch: "bonus/bunch-update",
  bonusItem: "bonus",
  gameSpinsList: "bonus/freespin/settings",
  loyaltyLevels: "loyalty/level/list",
  loyaltyLevelCreate: "loyalty/level/create",
  loyaltyLevelUpdate: "loyalty/level/update",
  loyaltyLevelUpdateBunch: "loyalty/level/bunch-update",
  loyaltyLevelDelete: "loyalty/level/delete",
  loyaltyLevelItem: "loyalty/level",
  loyaltyLevelRewards: "loyalty/level",
  loyaltyLevelSetTranslations: "loyalty/level/set-translation",
  loyaltyLevelGetTranslations: "loyalty/level/translation",
  loyaltyPoints: "loyalty/point/list",
  loyaltyPointsCreate: "loyalty/point/create",
  loyaltyPointsUpdate: "loyalty/point/update",
  loyaltyPointsDelete: "loyalty/point/delete",
  loyaltyPointsItem: "loyalty/point",
  depositPointLimits: "loyalty/deposit-point-limit/list",
  depositPointLimitCreate: "loyalty/deposit-point-limit/create",
  depositPointLimitUpdate: "loyalty/deposit-point-limit/update",
  depositPointLimitDelete: "loyalty/deposit-point-limit/delete",
  depositPointLimitItem: "loyalty/deposit-point-limit",
  depositPointLimitPeriod: "loyalty/deposit-point-limit/period",
  cashbacksList: "cashback/list",
  cashbackCreate: "cashback/create",
  cashbackUpdate: "cashback/update",
  cashbackUpdateBunch: "cashback/bunch-update",
  cashbackDelete: "cashback/delete",
  cashbackUpdateConfig: "cashback/set-config",
  cashbackItem: "cashback",
  tournamentsStatusesList: "tournament/status/list",
  tournamentsList: "tournament/list",
  tournamentsCreate: "tournament/create",
  tournamentsUpdate: "tournament/update",
  tournamentsBunchUpdate: "tournament/bunch-update",
  tournamentsDelete: "tournament/delete",
  tournamentsItem: "tournament",
  tournamentsSetRules: "tournament/rule/set",
  tournamentsSetScores: "tournament/score/set",
  tournamentsSetRewards: "tournament/reward/set",
  tournamentsSetContent: "tournament/content/set",
  tournamentsAddGames: "tournament/add-games",
  tournamentGamesList: "tournament/games",
  promoCodeList: "promocode/list",
  promoCodeCreate: "promocode/create",
  promoCodeUpdate: "promocode/update",
  promoCodeUpdateBunch: "promocode/bunch-update",
  promoCodeDelete: "promocode/delete",
  promoCodeItem: "promocode",
  promoCodeBonusMaskCreate: "promocode/bonus-mask/create",
  promoCodeBonusMaskUpdate: "promocode/bonus-mask",
  promoCodeBonusMaskList: "promocode/bonus-mask/list",
  promoCodeBonusMaskItem: "promocode/bonus-mask",
  cashbacksGamesListGames: "game/cashback/not-processed-games",
  cashbacksGamesListGamesAll: "game/cashback/games",
  cashbacksGamesList: "game/cashback/list",
  cashbacksGamesCreate: "game/cashback/create",
  cashbacksGamesUpdate: "game/cashback/update",
  cashbacksGamesItem: "game/cashback",
  cashbacksGamesDelete: "game/cashback/delete",
  cashbackRemoveGames: "game/cashback",
  customizedList: "cms/custom/list",
  customizedCreate: "cms/custom/create",
  customizedUpdate: "cms/custom/update",
  customizedUpdateBunch: "cms/custom/bunch-update",
  customizedDelete: "cms/custom/delete",
  customizedItem: "cms/custom",
  customizedItems: "cms/widgets/custom/items",
  getCustomizedItemLocale: "cms/custom/translation",
  setCustomizedItemLocale: "cms/custom/set-translation",
  // Players
  playersList: "user/list",
  playerCasinoBetsList: "bet/user/history",
  playerDepositsList: "payment/user/deposits",
  playerWithdrawalsList: "payment/user/withdrawals",
  playerPaymentInfo: "payment/user/info",
  playerNotifsList: "notification/user",
  playerItem: "user/info/main",
  playerUpdate: "user/info/soft-update",
  playerKycProfile: (userId: number) => `user/kyc/profile/${userId}`,
  playerRiskList: "user/risk/list",
  playerNoticesList: "note/list",
  playerNoticeCreate: "note/create",
  playerCategoriesList: "user/category/list",
  playerVerificationStatusesList: "user/verification/list",
  playerActivitiesList: "log/user/activities",
  playerBonuses: "bonus/user",
  playerLoyalty: "loyalty/user",
  playerCashbacks: "cashback/user/history",
  playerPromocodes: "promocode/user/history",
  playerRestrictions: "user/limit",
  playerRestrictionsSet: "user/limit/set",
  playerRiskProfile: "user/risk/profile",
  playerRiskProfileSet: "user/risk/profile",
  playerRiskCalculated: "user/restriction/calculated",
  playerRiskRestrictions: "user/restriction/manual",
  playerWagering: "payment/user/withdrawal-wager-buckets",
  playerSportBetsList: "bet/user/sport-history",
  presetsList: "presets/list",
  presetsItem: "presets",
  presetsDelete: "presets/delete",
  presetsCreate: "presets/create",
  presetsUpdate: "presets/update",
  // Segments
  segmentsList: "segment/list",
  createSegment: "segment/create",
  editSegment: "segment/update",
  deleteSegment: "segment/delete",
  segmentItem: "segment",
  addUsersToSegments: "segment/add-users-multi",
  segmentUsersList: "segment/users",
  segmenSetRule: "segment/set-rule",
  // Setting
  appModules: "system/platform-modules",
  appGeoList: "system/geos",
  seoTypes: "system/seo-pages",
  appCurrencyList: "system/currencies",
  appPayoutCurrencyList: "system/payout-currencies",
  appLocalesList: "system/locales",
  appServicesList: "system/services",
  appCountryList: "system/countries",
  // Risk
  riskPermissionsList: "/user/risk-permission-matrix/list",
  riskPermissionsUpdate: "/user/risk-permission-matrix",
  riskPermissionsItem: "/user/risk-permission-matrix",
  riskLimitsList: "/user/risk-permission-matrix/limits",
  riskLimitsUpdate: "/user/risk-permission-matrix/limits",
  riskPlayersList: "/user/risk/players/list",
  riskKycDocumentsList: "/user/kyc/documents/list",
  riskKycDocumentsOptions: "/user/kyc/document-options",
  riskKycDocumentPreview: (userId: number, documentId: number) =>
    `/user/kyc/documents/${userId}/${documentId}/preview`,
  riskKycDocumentsUpload: (userId: number) => `/user/kyc/documents/${userId}`,
  riskKycDocumentsByUser: (userId: number) => `/user/kyc/documents/${userId}`,
  riskKycDocumentReview: (documentId: number) =>
    `/user/kyc/documents/${documentId}/review`,
  verificationProfileDataRequirements:
    "user/verification/profile-data/requirements",
  verificationProfileData: (userId: number) =>
    `user/verification/profile-data/${userId}`,
  verificationState: (userId: number) => `user/verification/${userId}`,
  approveVerification: (userId: number) =>
    `user/verification/approve/${userId}`,
  riskKycPresetsList: "/user/kyc/requirement-presets",
  riskKycRulesList: "/user/kyc/rule-definitions",
  riskKycPresetRulesList: "/user/kyc/requirement-preset-rules",
  // Roles
  rolesList: "user/role/list",
  roleItem: "user/role",
  roleCreate: "user/role/create",
  roleUpdate: "user/role",
  roleAddPermission: "user/role/add-role-permission",
  // CMS
  mainPageList: "cms/widgets/main-page",
  mainPageUpdate: "cms/widgets/main-page/set",
  casinoPageList: "cms/widgets/casino",
  casinoPageUpdate: "cms/widgets/casino/set",
  liveCasinoPageList: "cms/widgets/live-casino",
  liveCasinoPageUpdate: "cms/widgets/live-casino/set",
  burgerMenuItems: "cms/widgets/burger-menu/items",
  signUpItems: "cms/widgets/sign-up-form/items",
  signUpList: "cms/widgets/sign-up-form",
  signUpUpdate: "cms/widgets/sign-up-form/set",
  preDepositItems: "cms/widgets/pre-deposit-form/items",
  preDepositList: "cms/widgets/pre-deposit-form",
  preDepositUpdate: "cms/widgets/pre-deposit-form/set",
  bonusWelcome: "bonus/welcome",
  mobileMenuList: "cms/widgets/mobile-menu",
  mobileMenuItems: "cms/widgets/mobile-menu/items",
  mobileMenuUpdate: "cms/widgets/mobile-menu/set",
  burgerMenuList: "cms/widgets/burger-menu",
  burgerMenuUpdate: "cms/widgets/burger-menu/set",
  gameBarList: "cms/widgets/game-bar",
  gameBarUpdate: "cms/widgets/game-bar/set",
  bannersList: "cms/banners/group/list",
  bannersCreateGroup: "cms/banners/group/create",
  bannersUpdateGroup: "cms/banners/group/update",
  bannersDeleteGroup: "cms/banners/group/delete",
  bannersGroupItem: "cms/banners/group",
  bannersCreate: "cms/banners/create",
  bannersUpdate: "cms/banners/update",
  bannersDelete: "cms/banners/delete",
  bannersItem: "cms/banners",
  pagesList: "cms/page/list",
  pagesCreate: "cms/page/create",
  pagesUpdate: "cms/page/update",
  pagesDelete: "cms/page/delete",
  pagesItem: "cms/page",
  seoList: "/cms/pages/seo/list",
  seoCreate: "/cms/pages/seo/create",
  seoUpdate: "/cms/pages/seo/update",
  seoDelete: "/cms/pages/seo/delete",
  seoGet: "/cms/pages/seo",
  faqList: "/cms/pages/faq/list",
  faqCreate: "/cms/pages/faq/create",
  faqUpdate: "/cms/pages/faq/update",
  faqDelete: "/cms/pages/faq/delete",
  faqGet: "/cms/pages/faq",
  faqTranslation: "/cms/pages/faq/translation",
  getPagesItemLocale: "cms/page/translation",
  setPagesItemLocale: "cms/page/set-translation",
  getPromoItemLocale: "cms/promo/translation",
  setPromoItemLocale: "cms/promo/set-translation",
  promoItem: "cms/promo",
  promoList: "cms/promo/list",
  promoCreate: "cms/promo/create",
  promoUpdate: "cms/promo/update",
  promoDelete: "cms/promo/delete",
  gamesWidgetList: "cms/game/widget/list",
  tokenWidgetList: "cms/token/widget/list",
  updatePagesBunch: "cms/page/bunch-update",
  updateBannersBunch: "cms/banners/group/bunch-update",
  updatePromosBunch: "cms/promo/bunch-update",
  headerItems: "cms/widgets/header/items",
  profileMenuItems: "cms/widgets/profile-menu/items",
  profileMenu: "cms/widgets/profile-menu",
  headerList: "cms/widgets/header",
  headerUpdate: "cms/widgets/header/set",
  profileMenuUpdate: "cms/widgets/profile-menu/set",
  footerPage: "cms/widgets/footer",
  footerItems: "cms/widgets/footer/items",
  footerUpdate: "cms/widgets/footer/set",
  partnersList: "cms/footer/partners/list",
  partnersCreate: "cms/footer/partners/create",
  partnersItem: "cms/footer/partners",
  partnersUpdate: "cms/footer/partners/update",
  partnersBunchUpdate: "cms/footer/partners/bunch-update",
  partnersDelete: "cms/footer/partners/delete",
  partnersDeleteBanner: "cms/footer/partners/delete-media",
  socialNetworksList: "cms/footer/social-networks/list",
  socialNetworksCreate: "cms/footer/social-networks/create",
  socialNetworksItem: "cms/footer/social-networks",
  socialNetworksUpdate: "cms/footer/social-networks/update",
  socialNetworksBunchUpdate: "cms/footer/social-networks/bunch-update",
  socialNetworksDelete: "cms/footer/social-networks/delete",
  socialNetworksDeleteBanner: "cms/footer/social-networks/delete-media",
  applicationsList: "cms/footer/applications/list",
  applicationsDelete: "cms/footer/applications/delete",
  applicationsItem: "cms/footer/applications",
  applicationsUpdate: "cms/footer/applications/update",
  applicationsCreate: "cms/footer/applications/create",
  applicationsBunchUpdate: "cms/footer/applications/bunch-update",
  mainTextList: "cms/footer/main-text/list",
  mainTextDelete: "cms/footer/main-text/delete",
  mainTextItem: "cms/footer/main-text",
  mainTextUpdate: "cms/footer/main-text/update",
  mainTextCreate: "cms/footer/main-text/create",
  mainTextGetLocale: "cms/footer/main-text/translation",
  mainTextSetLocale: "cms/footer/main-text/set-translation",
  mainTextBunchUpdate: "cms/footer/main-text/bunch-update",
  brandCoreList: "cms/footer/brand-core/list",
  brandCoreDelete: "cms/footer/brand-core/delete",
  brandCoreItem: "cms/footer/brand-core",
  brandCoreUpdate: "cms/footer/brand-core/update",
  brandCoreCreate: "cms/footer/brand-core/create",
  brandCoreBunchUpdate: "cms/footer/brand-core/bunch-update",
  paymentsList: "cms/footer/payments/list",
  paymentsDelete: "cms/footer/payments/delete",
  paymentsItem: "cms/footer/payments",
  paymentsUpdate: "cms/footer/payments/update",
  paymentsCreate: "cms/footer/payments/create",
  paymentsBunchUpdate: "cms/footer/payments/bunch-update",
  // Game center
  gamesList: "game/list",
  gameTypes: "game/types",
  gameUpdate: "game/update",
  gameRead: "game",
  gameInit: "game/init",
  collectionsBase: "game/collection",
  collectionsList: "game/collection/list",
  collectionDelete: "game/collection/delete",
  collectionCreate: "game/collection/create",
  collectionUpdate: "game/collection/update",
  collectionRead: "game/collection",
  categoriesList: "game/category/list",
  categoryDelete: "game/category/delete",
  categoryCreate: "game/category/create",
  categoryUpdate: "game/category/update",
  categoryRead: "game/category",
  tagBase: "game/tag",
  tagsList: "game/tag/list",
  tagsDelete: "game/tag/delete",
  tagsCreate: "game/tag/create",
  tagsUpdate: "game/tag/update",
  tagsRead: "game/tag",
  tagRemoveGames: "game/tag",
  collectionRemoveGames: "game/collection",
  providersList: "game/provider/list",
  providerUpdate: "game/provider/update",
  providerItem: "game/provider",
  providerDelete: "game/provider/delete",
  gameParseGames: "game/vendor/parse",
  collectionGamesList: "game/search-by-collections",
  tagGamesList: "game/search-by-tags",
  collectionGamesOrder: "game/collection",
  tagGamesOrder: "game/tag",
  gameBunchUpdate: "game/bunch-update",
  getRestrictionsCountriesList: "game/restrictions",
  setRestrictionsCountriesList: "game/set-restrictions",
  updateProvidersBunch: "game/provider/bunch-update",
  updateTagsBunch: "game/tag/bunch-update",
  updateCollectionsBunch: "game/collection/bunch-update",
  updateCategoriesBunch: "game/category/bunch-update",
  multiScopeBase: "game/multi-scope",
  multiScopeList: "game/multi-scope/list",
  multiScopeCreate: "game/multi-scope/create",
  multiScopeUpdate: "game/multi-scope/update",
  multiScopeDelete: "game/multi-scope/delete",
  //Scheduler
  schedulerList: "scheduler/list",
  schedulerItem: "scheduler",
  schedulerItemDelete: "scheduler/delete",
  schedulerItemCreate: "scheduler/create",
  schedulerItemUpdate: "scheduler/update",
};
